// extracted by mini-css-extract-plugin
module.exports = {"TopFace":"Face_TopFace__2Tum6","RightFace":"Face_RightFace__XLrcb","FrontFace":"Face_FrontFace__2Sq39"};